import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { DiagnosisSection } from '../components/DiagnosisSection';
import { SystemSection } from '../components/SystemSection';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon text-white selection:bg-gold/30 selection:text-white" data-id="element-56">
      <HeroSection data-id="element-57" />
      <DiagnosisSection data-id="element-58" />
      <SystemSection data-id="element-59" />
      <FinalCTA data-id="element-60" />
    </main>;
}